export const isFreeVersion = () => {
  return window.location.hostname === 'haccpforfree.com';
};




// WEBPACK FOOTER //
// ./helpers.js